module.exports = __webpack_public_path__ + "static/media/NoImageFood.eb704dd9.png";